(function(){
  var COLORES=[
    {n:'Natural',v:'50083848192242',s:'301',h:'#F0CBA8'},
    {n:'Cedro',v:'50083848225010',s:'302',h:'#C16D46'},
    {n:'Roble Claro',v:'50083848257778',s:'303',h:'#DCA068'},
    {n:'Roble Oscuro',v:'50083848290546',s:'304',h:'#7B492E'},
    {n:'Nogal',v:'50083848323314',s:'305',h:'#7E4C32'},
    {n:'Pino',v:'50083848356082',s:'306',h:'#F4CB8E'},
    {n:'Caoba',v:'50083848388850',s:'307',h:'#92432D'},
    {n:'Viraro',v:'50083848421618',s:'308',h:'#BB7644'}
  ];
  // Escalera de precios. Para cambiar la oferta se toca SOLO esto, y hay que
  // ajustar el descuento automatico de Shopify que le corresponde:
  //   2 potes -> descuento $610   (DiscountAutomaticNode/1520040542450)
  //   3 potes -> descuento $1.160 (DiscountAutomaticNode/1520040607986)
  var UNIT=1150;
  var PACKS=[
    {q:1,total:1150,sub:'para una reparación puntual'},
    {q:2,total:1690,badge:'El más elegido'},
    {q:3,total:2290}
  ];
  var qty=2;            // pack elegido por defecto
  var elegidos=[0,0,0]; // indice de color por pote
  var potePos=0;        // pote que se esta editando

  function fmt(n){ return '$'+n.toLocaleString('es-UY'); }
  function pack(){ for(var i=0;i<PACKS.length;i++){ if(PACKS[i].q===qty) return PACKS[i]; } return PACKS[0]; }

  var mount=document.getElementById('msel-mount'); if(!mount) return;
  mount.innerHTML='<div class="msel" data-msel>'
    +'<div class="msel__head"><span class="msel__step">PASO 1</span><h3 class="msel__title">Elegí cuántos</h3></div>'
    +'<div class="msel__qty" data-qty></div>'
    +'<div class="msel__head msel__head--2"><span class="msel__step">PASO 2</span><h3 class="msel__title" data-t2>Elegí el color</h3><span class="msel__pick" data-pick></span></div>'
    +'<div class="msel__potes" data-potes></div>'
    +'<div class="msel__grid" data-grid></div>'
    +'<div class="msel__total" data-total></div>'
    +'</div>';
  var root=mount.querySelector('[data-msel]');

  function pintarPacks(){
    var h='';
    PACKS.forEach(function(p){
      var lleno=UNIT*p.q, cu=Math.round(p.total/p.q), save=lleno-p.total;
      h+='<button type="button" class="msel__pack'+(p.q===qty?' is-on':'')+'" data-q="'+p.q+'">';
      if(p.badge){ h+='<span class="msel__badge">'+p.badge+'</span>'; }
      h+='<span class="msel__radio"></span><span class="msel__packtxt"><b>'+p.q+(p.q===1?' pote':' potes')+'</b><small>'+(p.sub||fmt(cu)+' cada uno')+'</small>';
      if(save>0){ h+='<span class="msel__save">ahorrás '+fmt(save)+'</span>'; }
      h+='</span><span class="msel__packprice"><b>'+fmt(p.total)+'</b>'+(p.q>1?'<s>'+fmt(lleno)+'</s>':'')+'</span></button>';
    });
    root.querySelector('[data-qty]').innerHTML=h;
  }
  function pintarPotes(){
    var cont=root.querySelector('[data-potes]');
    if(qty===1){ cont.innerHTML=''; cont.style.display='none'; return; }
    cont.style.display='';
    var h='';
    for(var i=0;i<qty;i++){
      var c=COLORES[elegidos[i]];
      h+='<button type="button" class="msel__pote'+(i===potePos?' is-on':'')+'" data-pote="'+i+'">'
        +'<span class="msel__potedot" style="background:'+c.h+'"></span>'
        +'<span class="msel__potetxt"><b>Pote '+(i+1)+'</b><small>'+c.n+'</small></span></button>';
    }
    cont.innerHTML=h;
  }
  function pintarGrid(){
    var h='';
    COLORES.forEach(function(c,i){
      h+='<button type="button" class="msel__opt'+(i===elegidos[potePos]?' is-on':'')+'" data-c="'+i+'" aria-label="'+c.n+'">'
        +'<span class="msel__chip" style="background:'+c.h+'"></span><span class="msel__label">'+c.n+'</span></button>';
    });
    root.querySelector('[data-grid]').innerHTML=h;
    root.querySelector('[data-t2]').textContent = qty===1 ? 'Elegí el color' : 'Elegí el color de cada pote';
    root.querySelector('[data-pick]').textContent = qty===1 ? COLORES[elegidos[0]].n : 'Pote '+(potePos+1);
  }
  function pintarTotal(){
    var p=pack(), lleno=UNIT*p.q;
    root.querySelector('[data-total]').innerHTML='<span class="msel__tlab">Total</span><span class="msel__tval">'+fmt(p.total)+'</span>'+(p.q>1?'<s>'+fmt(lleno)+'</s>':'');
    var btns=document.querySelectorAll('.product-form__submit, button[name="add"]');
    btns.forEach(function(b){
      var t=b.querySelector('span'); var txt='Agregar al carrito · '+fmt(p.total);
      if(t){ t.textContent=txt; } else { b.textContent=txt; }
    });
  }
  function pintar(){ pintarPacks(); pintarPotes(); pintarGrid(); pintarTotal(); }

  root.addEventListener('click',function(e){
    var b=e.target.closest('[data-q]');
    if(b){ qty=parseInt(b.getAttribute('data-q'),10);
      if(potePos>=qty){ potePos=qty-1; }
      for(var i=1;i<qty;i++){ if(elegidos[i]===undefined){ elegidos[i]=elegidos[0]; } }
      pintar(); return; }
    var p=e.target.closest('[data-pote]');
    if(p){ potePos=parseInt(p.getAttribute('data-pote'),10); pintarPotes(); pintarGrid(); return; }
    var c=e.target.closest('[data-c]');
    if(c){ elegidos[potePos]=parseInt(c.getAttribute('data-c'),10);
      if(qty>1 && potePos<qty-1){ potePos++; }
      pintarPotes(); pintarGrid(); return; }
  });

  // ---- agregar al carrito: una linea por color elegido ----
  function itemsDelCarrito(){
    var map={};
    for(var i=0;i<qty;i++){ var v=COLORES[elegidos[i]].v; map[v]=(map[v]||0)+1; }
    return Object.keys(map).map(function(v){ return {id:parseInt(v,10), quantity:map[v]}; });
  }
  function abrirCarrito(){
    var d=document.querySelector('cart-drawer');
    if(d && typeof d.open==='function'){ try{ d.open(); return; }catch(e){} }
    window.location.href='/cart';
  }
  var forms=[].slice.call(document.querySelectorAll('form[action*="/cart/add"]'))
    .filter(function(f){ return !f.closest('#shopify-section-cart-drawer'); });
  forms.forEach(function(f){
    f.addEventListener('submit',function(ev){
      ev.preventDefault(); ev.stopImmediatePropagation();
      var btn=f.querySelector('[name="add"], .product-form__submit');
      if(btn){ btn.setAttribute('aria-busy','true'); btn.disabled=true; }
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:itemsDelCarrito()})})
        .then(function(r){ return r.json(); })
        .then(function(){ if(btn){ btn.disabled=false; btn.removeAttribute('aria-busy'); } abrirCarrito(); })
        .catch(function(){ if(btn){ btn.disabled=false; btn.removeAttribute('aria-busy'); } window.location.href='/cart'; });
    }, true);
  });

  pintar();
})();